import { Checkbox } from "@mui/material";
import { iDataNivelAsignatura } from "../../../../interfaces/SuperAdmin/Pages/iDataNivel";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../ui-components/StyledTables";
import { formatFechaWithHour } from "../../../../utils/dateFunctions";

interface Props {
  nivelAsign: iDataNivelAsignatura;
  i: number;
  isSelected: boolean;
  handleSelect: (id: string) => void;
}

export const SingleNivelRow: React.FC<Props> = ({
  nivelAsign,
  i,
  isSelected,
  handleSelect,
}) => {
  const { asignatura, created_at, estado } = nivelAsign;

  return (
    <StyledTableRow>
      <StyledTableCell>
        <Checkbox
          color="primary"
          checked={isSelected}
          onChange={() => handleSelect(nivelAsign.id_nivel_asignatura)}
        />
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>{i}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center", maxWidth: 400 }}>
        {asignatura}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {formatFechaWithHour(created_at)}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {estado}
      </StyledTableCell>
    </StyledTableRow>
  );
};
